import { Utility } from "../../../../../common/utility";

export class CustomRowAction {
    public actionJSON: any = {};
    private utility: Utility;
    constructor(actionObject: any) {
        this.utility = new Utility();
        this.formActionJSON(actionObject);
    }

    formActionJSON(actionObject: any) {
        if (actionObject.isRuleApplied) {
            if (actionObject.isVisible === 'true') {
                this.actionJSON = {
                    rowFormRules: {
                        [actionObject.name]: {
                            fields: actionObject.visibilityRuleFields,
                            ...actionObject.visibilityRuleObj
                        }
                    }
                }
            } else {
                this.actionJSON = {
                    rowFormRules: {
                        [actionObject.name]: actionObject.visibilityRuleObj
                    }
                }
            }
            const compName =  actionObject.actionType === 'VF_PAGE' ? actionObject.componentName : this.utility.toKebabStyle(actionObject.componentName);
            this.actionJSON = {
                ...this.actionJSON,
                rowActions: {
                    label: actionObject.label,
                    name: actionObject.name,
                    component_name: compName,
                    component_namespace: actionObject.componentNameSpace,
                    action_type: actionObject.actionType,
                    pop_up: actionObject.popupType,
                }
            }
        } else {
            
            const compName = actionObject.actionType === 'VF_PAGE' ? actionObject.componentName : this.utility.toKebabStyle(actionObject.componentName);
            this.actionJSON = {
                rowActions: {
                    label: actionObject.label,
                    name: actionObject.name,
                    component_name: compName,
                    component_namespace: actionObject.componentNameSpace,
                    action_type: actionObject.actionType,
                    pop_up: actionObject.popupType,
                }
            }
        }
        return this.actionJSON;
    }

}